module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("67Hxz"))).then(() => parcelRequire('f4eak'));